module.exports = __webpack_public_path__ + "static/media/chevron-up.44ec2369.svg";